import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { GlobalStyle } from './Globals';
import { themes } from './theme';
import { useStore } from './stores/store';
import { Layout } from './components/Layout';
import { AppRoutes } from './router';

export function App() {
  const themeName = useStore((s) => s.theme);
  return (
    <ThemeProvider theme={themes[themeName]}>
      <GlobalStyle />
      <BrowserRouter basename={process.env.PUBLIC_URL || undefined}>
        <Layout>
          <AppRoutes />
        </Layout>
      </BrowserRouter>
    </ThemeProvider>
  );
}
